<template>
	<div class="nis-score-rings" :class="{ 'nis-score-rings--portal': isPortalView }">
		<h2 class="text-center darkColor--text nis-score-title">{{ title }}</h2>
		<div class="nis-rings-grid">
			<div
				v-for="(item, idx) in parts"
				:key="idx"
				class="nis-ring-cell"
				:class="{ inactive: item.score == null }"
			>
				<div class="nis-ring-label" :style="{ color: item.color }">
					{{ item.label }}
				</div>
				<vue-ellipse-progress
					:progress="item.score == null ? 100 : item.score"
					:thickness="ringThickness"
					:emptyColor="item.score != null ? '#d7d7d7' : '#b1b3b2'"
					:color="item.score != null ? item.color : '#b1b3b2'"
					:size="ringSize"
					class="mx-auto"
				>
					<v-img
						:src="item.icon"
						:max-width="iconSize"
						contain
						class="mx-auto"
					/>
				</vue-ellipse-progress>
				<div class="nis-ring-score" :style="{ color: item.color }">
					{{ item.score != null ? Math.ceil(item.score) + "%" : "-" }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { VueEllipseProgress } from "vue-ellipse-progress"
export default {
	name: "NisScoreRings",
	components: { VueEllipseProgress },
	props: {
		title: String,
		score1: Number,
		score2: Number,
		score3: Number,
		score4: Number,
		score5: Number,
		score6: Number,
		isPortalView: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		ringSize() {
			return this.isPortalView ? 72 : 56
		},
		ringThickness() {
			return this.isPortalView ? 10 : 7
		},
		iconSize() {
			return this.isPortalView ? "54px" : "46px"
		},
		parts() {
			const teal = "#1E7C83"
			const yellow = "#DE8F18"
			return [
				{
					label: "Governance & Risk Management",
					score: this.score1,
					color: teal,
					icon: require("../assets/NIS_Governance.svg"),
				},
				{
					label: "Incident Handling & Reporting",
					score: this.score2,
					color: yellow,
					icon: require("../assets/NIS_Incidents.svg"),
				},
				{
					label: "Business Continuity & Crisis Management",
					score: this.score3,
					color: teal,
					icon: require("../assets/NIS_Continuity.svg"),
				},
				{
					label: "Supply Chain & Third Parties",
					score: this.score4,
					color: yellow,
					icon: require("../assets/NIS_SupplyChain.svg"),
				},
				{
					label: "Technical & Operational Security",
					score: this.score5,
					color: teal,
					icon: require("../assets/NIS_Technical.svg"),
				},
				{
					label: "People, Training & HR Security",
					score: this.score6,
					color: yellow,
					icon: require("../assets/NIS_People.svg"),
				},
			]
		},
	},
}
</script>

<style scoped>
.inactive {
	filter: grayscale(100%);
}
.nis-score-rings {
	width: 100%;
}
.nis-score-title {
	font-size: 0.95rem;
	margin: 0 0 12px;
	min-height: 2.6em;
	display: flex;
	align-items: flex-end;
	justify-content: center;
	line-height: 1.3;
}
.nis-rings-grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 8px 6px;
	align-items: start;
}
.nis-ring-cell {
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	min-width: 0;
}
.nis-ring-label {
	height: 24px;
	width: 100%;
	max-width: 100px;
	margin: 0 auto 2px;
	font-size: 0.58rem;
	line-height: 1.1;
	font-weight: 700;
	letter-spacing: 0.01em;
	display: flex;
	align-items: flex-end;
	justify-content: center;
}
.nis-ring-score {
	font-size: 0.9rem;
	font-weight: 700;
	margin-top: 2px;
	line-height: 1.2;
}

/* Portal: one row of six, matching Sustainability portal section */
.nis-score-rings--portal .nis-score-title {
	font-size: 1.05rem;
	min-height: 2.8em;
}
.nis-score-rings--portal .nis-rings-grid {
	display: flex;
	flex-wrap: nowrap;
	justify-content: center;
	align-items: flex-start;
	gap: 10px;
}
.nis-score-rings--portal .nis-ring-cell {
	flex: 0 0 auto;
	width: 95px;
}
.nis-score-rings--portal .nis-ring-label {
	height: auto;
	min-height: 2.4em;
	max-width: 95px;
	font-size: 0.5rem;
	margin-bottom: 4px;
}
.nis-score-rings--portal .nis-ring-score {
	font-size: 0.95rem;
	margin-top: 4px;
}
</style>
